export function resizeContent(el) {
	const block = el;
	const blockWidth = block.clientWidth;
	const contentBlocks = block.getElementsByClassName("wp-block-new-standard-text-box__content");

	if ( contentBlocks.length ) {
		const contentBlock = contentBlocks[0];

		contentBlock.style.transform = "scale(1)";

		const contentBlockWidth = contentBlock.clientWidth;
		const contentBlockHeight = contentBlock.clientHeight;

		if ( contentBlockWidth && contentBlockHeight ) {
			let contentLongerSize = Math.max(contentBlockWidth, contentBlockHeight);

			const blockStyle = block.matches(".is-style-rectangle") ? "rectangle" : "circle";

			if ( "circle" === blockStyle ) {
				contentLongerSize = Math.floor( Math.sqrt( Math.pow(contentBlockWidth, 2) + Math.pow(contentBlockHeight, 2) ) );
			}

			if ( blockWidth < contentLongerSize ) {
				const scale = Math.floor( ( blockWidth / contentLongerSize ) * 100 ) / 100;
				contentBlock.style.transform = "scale(" + scale + ")";
			}
		}
	}
}
